import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProductFormPageRoutingModule } from './product-form-routing.module';

import { ProductFormPage } from './product-form.page';


import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { SharedModule } from '../../shared.module';
import { RouterModule } from '@angular/router';

import { ProductInventoryHistoryComponentModule } from '../product-inventory-history/product-inventory-hisotry.module';
import { ProductInventoryTrackerComponentModule } from '../product-inventory-tracker/product-inventory-tracker.module';

import { IonicSelectableModule } from 'ionic-selectable';

import { MaskitoModule } from '@maskito/angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ProductFormPageRoutingModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    SharedModule,
    RouterModule,
    IonicSelectableModule,
    ProductInventoryHistoryComponentModule,
    ProductInventoryTrackerComponentModule,
    MaskitoModule
  ],
  declarations: [ProductFormPage]
})
export class ProductFormPageModule {}
